export const AUTH_CONFIG = {
  clientId: 'JBE1gVOoX8UGgCcgb3hB82Jn9SfKZcft',
  domain: 'vlivemedia.auth0.com',
  callbackUrl: process.env.VUE_APP_AUTH
}